import { render } from "./orders.vue?vue&type=template&id=dd926d24"
import script from "./orders.vue?vue&type=script&lang=js"
export * from "./orders.vue?vue&type=script&lang=js"

import "./orders.vue?vue&type=style&index=0&id=dd926d24&lang=css"
script.render = render

export default script